import { render, staticRenderFns } from "./NfseList.vue?vue&type=template&id=bc5b8518&scoped=true&"
import script from "./NfseList.vue?vue&type=script&lang=js&"
export * from "./NfseList.vue?vue&type=script&lang=js&"
import style0 from "./NfseList.vue?vue&type=style&index=0&id=bc5b8518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5b8518",
  null
  
)

export default component.exports